import React from 'react';
import { motion } from 'framer-motion';
import { Wind, ShieldCheck, Smile } from 'lucide-react';
const steps = [{
  num: 1,
  icon: ShieldCheck,
  title: 'Place Around Your Neck',
  desc: 'Secure the soft velcro straps for a comfortable fit.'
}, {
  num: 2,
  icon: Wind,
  title: 'Inflate Gradually With Pump',
  desc: 'Squeeze the pump to reach your desired level of stretch.'
}, {
  num: 3,
  icon: Smile,
  title: 'Relax While Spine Decompresses',
  desc: 'Feel the tension melt away in just 10-15 minutes.'
}];
export function HowItWorks() {
  return <section className="bg-white py-16 lg:py-24 px-4 sm:px-6 lg:px-8" data-id="element-79">
      <div className="max-w-7xl mx-auto" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-81">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand-black" data-id="element-82">
            How It Works
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12 relative" data-id="element-83">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-brand-gray-light z-0" data-id="element-84"></div>

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative z-10 flex flex-col items-center text-center" data-id="element-85">
                <div className="w-24 h-24 bg-white rounded-full border-4 border-brand-purple-light flex items-center justify-center mb-6 relative shadow-sm" data-id="element-86">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-brand-purple text-white rounded-full flex items-center justify-center font-bold text-sm shadow-md" data-id="element-87">
                    {step.num}
                  </div>
                  <Icon className="w-10 h-10 text-brand-purple" data-id="element-88" />
                </div>
                <h3 className="text-xl font-bold mb-3 text-brand-black" data-id="element-89">
                  {step.title}
                </h3>
                <p className="text-brand-gray-dark" data-id="element-90">{step.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}